<template>
<div class="wrapper">
  <cabecalho tituloPagina="Agenda" v-bind:breadCrumbList="[]" />
  <menuLateral />

  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <b-button class="botoes" variant="outline-primary btn-sm" @click="incluirEvento()" :disabled="flagsDeControle.carregandoDados.status">Incluir</b-button>
            <b-button class="botoes ml-2" variant="outline-primary btn-sm" @click="redirecionarParaListagemConvites()" :disabled="flagsDeControle.carregandoDados.status">Convites</b-button>
          </div>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="card">
        <div class="card-body">
          <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
            <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
            <b-spinner class="ml-2" variant="danger"></b-spinner>
          </div>
          <FullCalendar v-if="!flagsDeControle.carregandoDados.status" ref="calendarioAgenda" id="calendar" :options="calendarOptions" :disabled="flagsDeControle.carregandoDados.status"/>
        </div>
      </div>
    </section>
  </div>
</div>
</template>

<script>
import Agenda from './js/agenda'
export default Agenda
</script>

<style scoped>
@import "./scss/agenda.scss";
@import "../../assets/scss/fullCalendarCustom.scss"
</style>
